import React, { Fragment, useEffect, useState } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Form, Nav, Dropdown, Tab, OverlayTrigger, Popover, Badge, Tooltip, Accordion, Button } from 'react-bootstrap'
import Card from '../../../components/Card'

import { Link, useLocation, useNavigate } from 'react-router-dom'


import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import { userSignal } from '../../../signal/userSignal';
import * as moment from 'moment';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import Circularprogressbar from '../../../components/circularprogressbar';
import SwiperCore, { Navigation } from "swiper";
import DataTable from 'react-data-table-component';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from '../../../signal/allUsersSignal';
import { dealerSignal } from '../../../signal/dealerSignal';
import CustomToggle from '../../../components/dropdowns';
import { confirmAlert } from 'react-confirm-alert';
import Avatar from 'react-avatar';
import { organisationSignal } from '../../../signal/organisationSignal';
import AddEditOrder from './AddEditOrder';
import TopLoader from "react-top-loader";
import EditTransportDetails from './EditTransportDetails';
import TallyInvoiceModal from './TallyInvoiceModal';
import AddReturnedItemModal from './AddReturnedItemModal';


// install Swiper modules
SwiperCore.use([Navigation]);

const OrderDetails = (props) => {


    const [toggler, setToggler] = useState();
    const [order, setOrder] = useState({});
    const [user, setUser] = useState({})
    const [dealer, setDealer] = useState({})
    const [showEditOrderModal, setShowEditOrderModal] = useState(false)
    const [showEditTransportDetailsModal, setShowEditTransportDetailsModal] = useState(false)
    const [showAddReturnedItemModal, setShowAddReturnedItemModal] = useState(false)
    const [showTallyInvoiceModal, setShowTallyInvoiceModal] = useState(false)
    const [initCalled, setInitCalled] = useState(false)

    const url = useLocation();
    const navigate = useNavigate();
    const id = url.pathname.split("/")[3];

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    const orderDetails = useMutation("orderDetails", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2/${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                setOrder(data.data);
                setUser(allUsersSignal.value[data?.data?.userId]);
                setDealer(data?.data?.dealer)
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            console.log(error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");

            }
            navigate("/dashboard/orders");
        }
    })

    const getInvoice = useQuery("invoice", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2/export-invoice/${order?.id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            responseType: 'arraybuffer'
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data) {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `invoice-${order?.id}.pdf`);
                document.body.appendChild(link);
                link.click();
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            }
        }

    });
    useEffect(() => {
        orderDetails.mutate()
        setInitCalled(true)
    }, [])

    const updateOrderStageMutation = useMutation((data) => axios.put(`${DEV_SERVER}/order/v2/updateOrderStage/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data?.data
            if (data.status) {
                toast.success(data.message);
                setOrder({ ...order, ...data?.data })
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const deleteOrderMutation = useMutation((id) => axios.delete(`${DEV_SERVER}/order/v2/${id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data?.data
            if (data.status) {
                toast.success(data.message);
                navigate("/dashboard/orders");
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const handleOrderStageUpdate = async (stage, isCompleted) => {
        let data = {
            id: id,
            body: {
                orderStage: stage?.name,
                isCompleted: isCompleted
            }
        }

        updateOrderStageMutation.mutate(data);
    }

    const handleDeleteOrder = () => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this order?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteOrderMutation.mutate(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    const orderItemsColumns = [
        {
            name: "Product Name",
            selector: "productId",
            cell: (row) => {
                return <div className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                    <Zoom><img src={(order?.products[row?.productId]?.images && order?.products[row?.productId]?.images?.length) > 0 && order?.products[row?.productId]?.images[0]?.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", width: "30px", height: "30px", borderRadius: "10px" }} /></Zoom>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{order?.products[row?.productId]?.name}</Tooltip>}>
                        <span>{order?.products[row?.productId]?.name}</span>
                    </OverlayTrigger>
                </div>
            },
            center: true,
        },
        {
            name: "Packaging Type",
            selector: "packagingType",
            center: true,
        },
        {
            name: "Quantity",
            selector: "quantity",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.quantity}</Tooltip>}>
                    <span>{row?.quantity}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Price",
            selector: "price",
            center: true,
        },
        {
            name: "Discount (in %)",
            selector: "discount",
            center: true,
            cell: (row) => {
                return `${row?.discount || 0}%`
            }
        },
        {
            name: "Total",
            selector: "total",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{
                `₹ ${parseFloat((row?.quantity * row?.price) - (row?.quantity * row?.price * row?.discount / 100)).toFixed(2)}`
                }</Tooltip>}>
                    <span>{`₹ ${parseFloat((row?.quantity * row?.price) - (row?.quantity * row?.price * row?.discount / 100)).toFixed(2)}`}</span>
                </OverlayTrigger>
            }
        }
    ]

    const returnedItemsColumns = [
        {
            name: "Product Name",
            selector: "productId",
            cell: (row) => {
                return <div className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                    <Zoom><img src={order?.products[row?.productId]?.images?.length > 0 && order?.products[row?.productId]?.images[0]?.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", width: "30px", height: "30px", borderRadius: "10px" }} /></Zoom>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{order?.products[row?.productId]?.name}</Tooltip>}>
                        <span>{order?.products[row?.productId]?.name}</span>
                    </OverlayTrigger>
                </div>
            },
            center: true,
        },
        {
            name: "Quantity",
            selector: "quantity",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.quantity}</Tooltip>}>
                    <span>{row?.quantity}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Packaging Type",
            selector: "packagingType",
            center: true,
        },
        {
            name: "Timestamp",
            selector: "createdAt",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{moment(row?.createdAt).format("DD/MM/YY hh:mm")}</Tooltip>}>
                    <span>{moment(row?.createdAt).format("DD/MM/YY hh:mm")}</span>
                </OverlayTrigger>
            }
        }
    ]

    const ExpandedComponent = ({ data }) => {

        return (
            <div className='d-flex flex-column'>
                <div className='d-flex'>
                    <p className='mb-0 w-75 text-end p-2' style={{ borderRight: "1px solid rgba(0, 0, 0, 0.12)", borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>Sub Total</p>
                    <p className='mb-0 w-25 text-center p-2' style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>₹ {parseFloat(order?.subTotal).toFixed(2)}</p>
                </div>

                {order?.taxes?.length > 0 ? order?.taxes?.map((tax) => {
                    return (
                        <div className='d-flex'>
                            <p className='mb-0 w-75 text-end p-2' style={{ borderRight: "1px solid rgba(0, 0, 0, 0.12)", borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>{`${tax?.name} ${tax?.taxInPercentage ? "("+tax?.taxInPercentage+"%)" : ''}`}</p>
                            <p className='mb-0 w-25 text-center p-2' style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>₹ {parseFloat(tax?.taxInAmount).toFixed(2)}</p>
                        </div>
                    )
                })
                    : <></>
                }

                <div className='d-flex'>
                    <p className='mb-0 w-75 text-end p-2' style={{ borderRight: "1px solid rgba(0, 0, 0, 0.12)", borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>Shipping Charges</p>
                    <p className='mb-0 w-25 text-center p-2' style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>₹ {parseFloat(order?.shippingCharges).toFixed(2)}</p>
                </div>

                <div className='d-flex'>
                    <span className='w-75 text-end p-2' style={{ borderRight: "1px solid rgba(0, 0, 0, 0.12)", borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}><b>Total Amount</b></span>
                    <span className='w-25 text-center p-2' style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>₹ {parseFloat(order?.totalAmount).toFixed(2)}</span>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            {getInvoice.isLoading && <div>
                <TopLoader backgroundColor="#eee6ff" show fixed={true} color="#0000e4" />
            </div>}
            {(orderDetails?.isLoading || orderDetails?.isFetching || !initCalled) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :
                <Tab.Container defaultActiveKey="first">
                    <Row>
                        <Col lg="12" style={{ marginTop: "3rem" }}>
                            <Card>
                                <Card.Body>
                                    <span className={`position-absolute top-0 translate-middle badge rounded-pill bg-none`} style={{ left: "99%", backgroundColor: organisationSignal?.value?.orderStageColors[order?.currentOrderStage] }}>
                                        {order?.currentOrderStage}
                                        <span className="visually-hidden">unread messages</span>
                                    </span>
                                    <span className='d-flex position-absolute' style={{ columnGap: "1rem", rowGap: "1rem", top: "-5%", right: "6%" }}>

                                        {(organisationSignal?.value?.isOrderModuleActivated && organisationSignal?.value?.isTallyIntegrationActivated) && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{"Sync With Tally"}</Tooltip>}>
                                            {/* <i style={{ cursor: "pointer" }} className='fa fa-edit fa-2x' ></i> */}
                                            <div class="bg-primary text-white px-2 py-1 rounded" style={{ cursor: "pointer" }} onClick={() => {
                                                if (order?.isTallySynced) {
                                                    confirmAlert({
                                                        title: 'Confirm to sync',
                                                        message: 'This order is already synced with Tally. Are you sure you want to sync it again?',
                                                        buttons: [
                                                            {
                                                                label: 'Yes',
                                                                onClick: () => setShowTallyInvoiceModal(true)
                                                            },
                                                            {
                                                                label: 'No',
                                                                onClick: () => { }
                                                            }
                                                        ]
                                                    });
                                                } else {
                                                    setShowTallyInvoiceModal(true)
                                                }
                                            }} width="25px" >

                                                <svg fill="#ffffff" width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                                                    <path d="M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" />
                                                    <path d="M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z" />
                                                </svg>
                                            </div>
                                        </OverlayTrigger>}

                                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{"Download Invoice"}</Tooltip>}>
                                            {/* <i style={{ cursor: "pointer" }} className='fa fa-edit fa-2x' ></i> */}
                                            <div class="bg-primary text-white px-2 py-1 rounded" style={{ cursor: "pointer" }} onClick={() => getInvoice.refetch({ cancelRefetch: true })} width="25px" >

                                                <svg class="icon-25" xmlns="http://www.w3.org/2000/svg" width="20px" fill="none" viewBox="0 0 24 24" stroke="#ffffff">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25 12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25ZM8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z" fill="#fffff"></path>
                                                </svg>
                                            </div>
                                        </OverlayTrigger>


                                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{"Edit Order"}</Tooltip>}>
                                            {/* <i style={{ cursor: "pointer" }} className='fa fa-edit fa-2x' ></i> */}
                                            <div class="bg-primary text-white px-2 py-1 rounded" style={{ cursor: "pointer" }} onClick={() => setShowEditOrderModal(true)}>
                                                <svg className="m-auto" xmlns="http://www.w3.org/2000/svg" width="20px" fill="none" viewBox="0 0 24 24" stroke="#ffffff">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="m3.99 16.854-1.314 3.504a.75.75 0 0 0 .966.965l3.503-1.314a3 3 0 0 0 1.068-.687L18.36 9.175s-.354-1.061-1.414-2.122c-1.06-1.06-2.122-1.414-2.122-1.414L4.677 15.786a3 3 0 0 0-.687 1.068zm12.249-12.63 1.383-1.383c.248-.248.579-.406.925-.348.487.08 1.232.322 1.934 1.025.703.703.945 1.447 1.025 1.934.058.346-.1.677-.348.925L19.774 7.76s-.353-1.06-1.414-2.12c-1.06-1.062-2.121-1.415-2.121-1.415z" fill="#ffffff"></path>
                                                </svg>
                                            </div>
                                        </OverlayTrigger>
                                        {/* <svg viewBox="-0.5 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>icon/18/icon-delete</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="out" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <path d="M4.91666667,14.8888889 C4.91666667,15.3571429 5.60416667,16 6.0625,16 L12.9375,16 C13.3958333,16 14.0833333,15.3571429 14.0833333,14.8888889 L14.0833333,6 L4.91666667,6 L4.91666667,14.8888889 L4.91666667,14.8888889 L4.91666667,14.8888889 Z M15,3.46500003 L12.5555556,3.46500003 L11.3333333,2 L7.66666667,2 L6.44444444,3.46500003 L4,3.46500003 L4,4.93000007 L15,4.93000007 L15,3.46500003 L15,3.46500003 L15,3.46500003 Z" id="path" fill="#e00b0b" sketch:type="MSShapeGroup"> </path> </g> </g></svg> */}
                                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{"Delete Order"}</Tooltip>}>
                                            <div class="bg-primary text-white p-2 rounded" onClick={handleDeleteOrder}>
                                                <i style={{ cursor: "pointer", width: "20px" }} className='fa fa-trash fa mx-auto d-flex justify-content-center' ></i>
                                            </div>
                                        </OverlayTrigger>


                                        {/* <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{"Delete Order"}</Tooltip>}><i style={{ cursor: "pointer" }} className='fa fa-trash fa-2x' onClick={handleDeleteOrder}></i></OverlayTrigger> */}
                                    </span>
                                    <div className='d-flex flex-column'>
                                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                                            <div className="d-flex flex-wrap align-items-center">
                                                <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                    {(dealer?.visitingCard?.length && dealer?.visitingCard?.length !== 0) ? <Image className="rounded-circle img-fluid avatar-100" src={dealer?.visitingCard[0]?.url} alt="profile-img" /> : <>
                                                        <Avatar name={dealer?.name} round style={{ borderRadius: "50% !important", margin: "0px auto", position: "relative", width: "200px !important", height: "200px !important" }} />
                                                    </>}
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                        <h4 className="me-2 h4">{dealer?.name}</h4>
                                                    </div>
                                                    <span>{dealer?.phoneNumber}</span>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column justify-content-center'>
                                                <span>Date: {moment(order?.createdAt).format("DD/MM/YY")}</span>
                                                {/* <span>{trip?.startTime ? moment(trip?.startTime).format("hh:mm A") : "-"} - {trip?.endTime ? moment(trip?.endTime).format("hh:mm A") : "-"}</span> */}
                                            </div>
                                        </div>
                                        <Row className="row-cols-1">
                                            <div className="d-slider1 ">
                                                <Swiper
                                                    className="p-0 m-0 mb-2 list-inline "
                                                    slidesPerView={5}
                                                    spaceBetween={32}
                                                    navigation={{
                                                        nextEl: ".swiper-button-next",
                                                        prevEl: ".swiper-button-prev",
                                                    }}
                                                    breakpoints={{
                                                        320: { slidesPerView: 1 },
                                                        550: { slidesPerView: 2 },
                                                        991: { slidesPerView: 3 },
                                                        1400: { slidesPerView: 3 },
                                                        1500: { slidesPerView: 4 },
                                                        1920: { slidesPerView: 4 },
                                                        2040: { slidesPerView: 7 },
                                                        2440: { slidesPerView: 8 }
                                                    }}

                                                >
                                                    <SwiperSlide className="card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.primary}
                                                                    width="60px"
                                                                    height="60px"
                                                                    Linecap="rounded"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={90}
                                                                    id="circle-progress-01"
                                                                >
                                                                    {order?.totalAmount === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Total Amount</p>
                                                                    <h4 className="counter">
                                                                        ₹ {order?.totalAmount > 1000 ? parseFloat(order?.totalAmount / 1000).toFixed(2) + "K" : parseFloat(order?.totalAmount).toFixed(2)}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className="card card-slide" >
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.info}
                                                                    width="60px"
                                                                    height="60px"
                                                                    Linecap="rounded"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={45}
                                                                    id="circle-progress-01"
                                                                >
                                                                    {order?.subTotal === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Sub Total</p>
                                                                    <h4 className="counter">
                                                                        ₹ {order?.subTotal > 1000 ? parseFloat(order?.subTotal / 1000).toFixed(2) + "K" : parseFloat(order?.subTotal).toFixed(2)}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className="card card-slide" >
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.primary}
                                                                    width="60px"
                                                                    height="60px"
                                                                    Linecap="rounded"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={75}
                                                                    id="circle-progress-01"
                                                                >
                                                                    {parseFloat(order?.totalAmount - order?.subTotal) === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Taxes + Shipping</p>
                                                                    <h4 className="counter">
                                                                        ₹ {(order?.totalAmount - order?.subTotal) > 1000 ? parseFloat((order?.totalAmount - order?.subTotal) / 1000).toFixed(2) + "K" : parseFloat((order?.totalAmount - order?.subTotal)).toFixed(2)}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className=" card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <img
                                                                    style={{ width: "60px", height: "60px" }}
                                                                    src={(user?.profileURL === "" || user?.profileURL === undefined) ? avatar1 : user?.profileURL}
                                                                    className="rounded-circle avatar-xs"
                                                                    alt="friend"
                                                                />
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">{user?.name || "NA"}</p>
                                                                    <h6 className="counter">
                                                                        {`Commission (${order?.userCommissionInPercentage}%): ₹ ${parseFloat(order?.userCommissionInAmount).toFixed(2)}`}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <div className="swiper-button swiper-button-next"></div>
                                                    <div className="swiper-button swiper-button-prev"></div>
                                                </Swiper>
                                            </div>
                                        </Row>

                                        <div className='d-flex w-100 justify-content-between' style={{ columnGap: "1rem" }}>

                                            <div className='col-6'>
                                                <Card>
                                                    <Card.Header><h4>Address Details</h4></Card.Header>
                                                    <Card.Body>

                                                        <div className='d-flex flex-column'>

                                                            {
                                                                // (order?.note && order?.note!=="") && 
                                                                <div className='d-flex' style={{ columnGap: "1rem" }}>
                                                                    <Card className="col-12 position-realtive p-0">
                                                                        <Card.Header>Additional Note</Card.Header>
                                                                        <Card.Body className="pb-0 me-3">
                                                                            <h5>{order?.note}</h5>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>}

                                                            <div className='d-flex' style={{ columnGap: "1rem" }}>
                                                                <Card className="col-12 position-realtive p-0">
                                                                    <Card.Header>Billing Address</Card.Header>
                                                                    <Card.Body className="pb-0 me-3">
                                                                        <h5>{order?.billingAddress?.addressL1 + " " + order?.billingAddress?.landmark}, {order?.billingAddress?.city} - {order?.billingAddress?.pincode}, {order?.billingAddress?.state}</h5>
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className='d-flex' style={{ columnGap: "1rem" }}>
                                                                <Card className="col-12 position-realtive p-0">
                                                                    <Card.Header>Shipping Address</Card.Header>
                                                                    <Card.Body className="pb-0 me-3">
                                                                        <h5>{order?.shippingAddress?.addressL1 + " " + order?.shippingAddress?.landmark}, {order?.shippingAddress?.city} - {order?.shippingAddress?.pincode}, {order?.shippingAddress?.state}</h5>
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </div>

                                            <div className='col-6'>
                                                <Card style={{ backgroundColor: "#adb5bd" }}>
                                                    <i className='fa fa-edit position-absolute' style={{ cursor: "pointer", right: "10%", top: "5%" }} onClick={() => setShowEditTransportDetailsModal(true)}></i>
                                                    <Card.Header><h4>Transport Details</h4></Card.Header>
                                                    <Card.Body>
                                                        <div className='d-flex flex-column' style={{ rowGap: "0.3rem" }}>
                                                            <div className='d-flex' style={{ columnGap: "1rem" }}>
                                                                <Card className="col-6 position-realtive p-0">
                                                                    <Card.Header>Eway Bill Number</Card.Header>
                                                                    <Card.Body className="pb-0 me-3">
                                                                        <h4>{order?.transportDetails?.ewayBillNumber}</h4>
                                                                    </Card.Body>

                                                                    <i className='fa fa-copy position-absolute' style={{ cursor: "pointer", right: "10%", top: "50%" }} onClick={() => navigator.clipboard.writeText(order?.transportDetails?.ewayBillNumber)}></i>
                                                                </Card>
                                                                <Card className="col-6 position-realtive p-0">
                                                                    <Card.Header>Doc Number</Card.Header>
                                                                    <Card.Body className="pb-0">
                                                                        <h4>{order?.transportDetails?.docNumber}</h4>
                                                                    </Card.Body>

                                                                    <i className='fa fa-copy position-absolute' style={{ cursor: "pointer", right: "10%", top: "50%" }} onClick={() => navigator.clipboard.writeText(order?.transportDetails?.docNumber)}></i>
                                                                </Card>
                                                            </div>

                                                            <div className='d-flex' style={{ columnGap: "1rem" }}>
                                                                <Card className="col-6 position-realtive p-0">
                                                                    <Card.Header>Vehicle Number</Card.Header>
                                                                    <Card.Body className="pb-0 me-3">
                                                                        <h4>{order?.transportDetails?.vehicleNumber}</h4>
                                                                    </Card.Body>

                                                                    <i className='fa fa-copy position-absolute' style={{ cursor: "pointer", right: "10%", top: "50%" }} onClick={() => navigator.clipboard.writeText(order?.transportDetails?.vehicleNumber)}></i>
                                                                </Card>
                                                                <Card className="col-6 position-realtive p-0">
                                                                    <Card.Header>Courier Name</Card.Header>
                                                                    <Card.Body className="pb-0">
                                                                        <h4>{order?.transportDetails?.courierName}</h4>
                                                                    </Card.Body>

                                                                    <i className='fa fa-copy position-absolute' style={{ cursor: "pointer", right: "10%", top: "50%" }} onClick={() => navigator.clipboard.writeText(order?.transportDetails?.courierName)}></i>
                                                                </Card>
                                                            </div>

                                                            <div className='d-flex' style={{ columnGap: "1rem" }}>
                                                                <Card className="col-6 position-realtive p-0">
                                                                    <Card.Header>Contact Person Details</Card.Header>
                                                                    <Card.Body className="pb-0 me-3">
                                                                        {order?.transportDetails?.contactPersonName ? <h4>{`${order?.transportDetails?.contactPersonName} ${order?.transportDetails?.contactPersonNumber ? "(" + order?.transportDetails?.contactPersonNumber + ")" : ""}`}</h4> : <h4></h4>}
                                                                    </Card.Body>

                                                                    <i className='fa fa-copy position-absolute' style={{ cursor: "pointer", right: "10%", top: "50%" }} onClick={() => navigator.clipboard.writeText(`${order?.transportDetails?.contactPersonName} (${order?.transportDetails?.contactPersonNumber})`)}></i>
                                                                </Card>
                                                                <Card className="col-6 position-realtive p-0">
                                                                    <Card.Header>Tracking Link</Card.Header>
                                                                    <Card.Body className="pb-0">
                                                                        <a href={order?.transportDetails?.trackingLink}>{order?.transportDetails?.trackingLink}</a>
                                                                    </Card.Body>

                                                                    <i className='fa fa-copy position-absolute' style={{ cursor: "pointer", right: "10%", top: "50%" }} onClick={() => navigator.clipboard.writeText(order?.transportDetails?.trackingLink)}></i>
                                                                </Card>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </div>


                                        <div className='d-flex justify-content-center align-items-center'>
                                            <Nav as="ul" className="d-flex nav-pills mb-0 text-center profile-tab" data-toggle="slider-tab" id="profile-pills-tab" role="tablist">
                                                <Nav.Item as="li">
                                                    <Nav.Link eventKey="first">Order Details</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item as="li">
                                                    <Nav.Link eventKey="second">Returned Items</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </div>

                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg="12">
                            <Tab.Content className="profile-content">
                                <Tab.Pane eventKey="first" id="profile-feed">
                                    <Col lg="12">
                                        {(orderDetails.isLoading || orderDetails?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                            <div className="spinner-border text-primary m-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div> :
                                            <Row>


                                                <Col sm={"9"} lg={"9"} md={"9"}>
                                                    <Card>
                                                        <Card.Body>
                                                            {<DataTable
                                                                defaultSortAsc={false}
                                                                columns={orderItemsColumns}
                                                                data={order?.orderItems}
                                                                pagination={false}
                                                                expandableRows
                                                                expandableRowsHideExpander={true}
                                                                expandableRowDisabled={(row) => row !== order?.orderItems[order?.orderItems.length - 1]}
                                                                expandableRowExpanded={(row) => row === order?.orderItems[order?.orderItems.length - 1]}
                                                                expandableRowsComponent={ExpandedComponent}
                                                            />}
                                                        </Card.Body>
                                                    </Card>
                                                </Col>

                                                <Col sm={"3"} lg={"3"} md={"3"}>
                                                    <Card>
                                                        <Card.Header><h4>Order Stage</h4></Card.Header>
                                                        <Card.Body>
                                                            <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                                                                <ul className="list-inline p-0 m-0">

                                                                    {order?.orderStages?.length && order?.orderStages?.map((stage, i) => {
                                                                        let color = organisationSignal?.value?.orderStageColors[stage?.name] || "black";
                                                                        return (
                                                                            <li>
                                                                                <div className="timeline-dots1">
                                                                                    <Form.Group color='success'>
                                                                                        <Form.Check disabled={updateOrderStageMutation?.isLoading} style={{ width: "40px", height: "40px" }} checked={stage?.isCompleted} onChange={(e) => handleOrderStageUpdate(stage, e.target.checked)} />
                                                                                    </Form.Group>
                                                                                </div>
                                                                                {/* <h6 className="mb-1" style={{backgroundColor: color, color: 'white'}}>{stage?.name}</h6> */}
                                                                                <Badge bg={'none'} style={{ backgroundColor: color }} className="float-left mb-1">{stage?.name}</Badge><br />
                                                                                {stage?.createdAt ? <small className="float-right mt-1">{moment(stage?.createdAt).format("DD/MM/YY hh:mm A")}</small> : <></>}
                                                                                <div className="d-inline-block w-100 mt-2">
                                                                                    {stage?.updatedBy !== "000000000000000000000000" && <p className='d-flex'>
                                                                                        <img
                                                                                            style={{ width: "30px", height: "30px" }}
                                                                                            src={(allUsersSignal?.value[stage?.updatedBy]?.profileURL === "" || allUsersSignal?.value[stage?.updatedBy]?.profileURL === undefined) ? avatar1 : allUsersSignal?.value[stage?.updatedBy]?.profileURL}
                                                                                            className="rounded-circle avatar-xs"
                                                                                            alt="friend"
                                                                                        />
                                                                                        <p className='ms-2'>{allUsersSignal?.value[stage?.updatedBy]?.name}</p>
                                                                                    </p>}
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>

                                            </Row>
                                        }
                                    </Col>
                                </Tab.Pane>

                                <Tab.Pane eventKey="second" id="profile-feed">
                                    <Col lg="12">
                                        {(orderDetails.isLoading || orderDetails?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                            <div className="spinner-border text-primary m-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div> :
                                            <Row>
                                                <Col sm={"12"} lg={"12"} md={"12"}>
                                                    <Card>
                                                        <Card.Body>
                                                            <div>
                                                                <div className="d-flex justify-content-between">
                                                                    <h4>Returned Items</h4>
                                                                        <button className="btn btn-primary" onClick={() => setShowAddReturnedItemModal(true)}>Add Returned Item</button>
                                                                </div>

                                                            </div>
                                                            {<DataTable
                                                                defaultSortAsc={false}
                                                                columns={returnedItemsColumns}
                                                                data={order?.returnItems || []}
                                                                pagination={false}
                                                            />}
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        }
                                    </Col>
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>


                    </Row>
                </Tab.Container>
            }

            {showEditOrderModal && <AddEditOrder show={showEditOrderModal} order={order} close={() => setShowEditOrderModal(false)} refetchOrder={() => orderDetails.mutate()} />}

            {showEditTransportDetailsModal && <EditTransportDetails show={showEditTransportDetailsModal} order={order} close={() => setShowEditTransportDetailsModal(false)} refetchOrder={() => orderDetails.mutate()} />}

            {showTallyInvoiceModal && <TallyInvoiceModal show={showTallyInvoiceModal} order={order} close={() => setShowTallyInvoiceModal(false)} refetchOrder={() => orderDetails.mutate()} />}

            {showAddReturnedItemModal && <AddReturnedItemModal show={showAddReturnedItemModal} order={order} close={() => setShowAddReturnedItemModal(false)} refetchOrder={() => orderDetails.mutate()} />}

        </Fragment>
    )

}

export default OrderDetails;